/* OS Accessibility Trigger Control */
(function () {
  if (window.__osAccessibilityTriggerControlLoaded) return;
  window.__osAccessibilityTriggerControlLoaded = true;

  var MOBILE_BREAKPOINT = '(max-width: 899px)';

  var ALLOWED_SECTION_SELECTORS = [
    '[data-os-edd-top-shop]',
    '[data-os-jv-cvr-top-shop]',
    '[data-os-jv-select-flavors]'
  ];

  function pageContainsAllowedSection() {
    return ALLOWED_SECTION_SELECTORS.some(function (selector) {
      return !!document.querySelector(selector);
    });
  }

  function shouldHideAccessibilityTrigger() {
    var isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;

    return isMobile && pageContainsAllowedSection();
  }

  function updateTrigger(trigger, shouldHide) {
    if (!trigger) return;

    if (shouldHide) {
      trigger.style.setProperty('display', 'none', 'important');
      trigger.style.setProperty('visibility', 'hidden', 'important');
      trigger.style.setProperty(
        'pointer-events',
        'none',
        'important'
      );

      trigger.setAttribute('aria-hidden', 'true');
      trigger.setAttribute(
        'data-os-accessibility-trigger-hidden',
        'true'
      );

      return;
    }

    if (
      trigger.getAttribute(
        'data-os-accessibility-trigger-hidden'
      ) !== 'true'
    ) {
      return;
    }

    trigger.style.removeProperty('display');
    trigger.style.removeProperty('visibility');
    trigger.style.removeProperty('pointer-events');

    trigger.removeAttribute('aria-hidden');
    trigger.removeAttribute(
      'data-os-accessibility-trigger-hidden'
    );
  }

  function updateAccessibilityTriggerVisibility() {
    var shouldHide = shouldHideAccessibilityTrigger();

    document
      .querySelectorAll('.trigger-container')
      .forEach(function (trigger) {
        updateTrigger(trigger, shouldHide);
      });

    document.querySelectorAll('*').forEach(function (element) {
      if (!element.shadowRoot) return;

      element.shadowRoot
        .querySelectorAll('.trigger-container')
        .forEach(function (trigger) {
          updateTrigger(trigger, shouldHide);
        });
    });
  }

  function initAccessibilityTriggerControl() {
    if (window.__osAccessibilityTriggerObserverBound) {
      updateAccessibilityTriggerVisibility();
      return;
    }

    window.__osAccessibilityTriggerObserverBound = true;

    var queued = false;

    function queueUpdate() {
      if (queued) return;

      queued = true;

      window.requestAnimationFrame(function () {
        queued = false;
        updateAccessibilityTriggerVisibility();
      });
    }

    var observer = new MutationObserver(queueUpdate);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    window.addEventListener('resize', queueUpdate);

    document.addEventListener(
      'shopify:section:load',
      queueUpdate
    );

    document.addEventListener(
      'shopify:section:unload',
      queueUpdate
    );

    updateAccessibilityTriggerVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAccessibilityTriggerControl
    );
  } else {
    initAccessibilityTriggerControl();
  }
})();